import React from 'react';
import Button from '@mui/material/Button';
import { checkJobDetailsUrl } from '../../modules/utils';

interface WebsiteButtonProps {
  normalizedIcon: {
    jobdetails?: {
      webpageurl?: string;
    };
  };
}

const WebsiteButton: React.FC<WebsiteButtonProps> = ({ normalizedIcon }) => {
  return (
    normalizedIcon?.jobdetails?.webpageurl && (
      <Button
        variant="contained"
        sx={{ borderRadius: '20px', minWidth: '150px', mb: 1 }}
        href={checkJobDetailsUrl(normalizedIcon.jobdetails?.webpageurl) || ''}
        component="a"
        target="_blank"
        title={normalizedIcon.jobdetails?.webpageurl}
        rel="noopener noreferrer"
        className="roadwork-website-button"
      >
        Website
      </Button>
    )
  );
};

export default WebsiteButton;
